import React, { useCallback, useEffect, useState } from 'react';
import { GridContainer, Grid } from 'src/shared/grid';
import { Formik, Form } from 'formik';
import { TextField } from '@mui/material';
import Button from '@mui/material/Button';
import 'src/features/field-sample//FieldSample.scss';
import * as Yup from 'yup';
import { useAddAlert } from 'src/store/actions';
import { useStoreContext } from 'src/store/context';
import { alertMessages } from 'src/constants';
import { errorResponse, regex2decimals} from 'src/store/common';
import { createUpdateDeadCatalogCall } from 'src/apis/mutationCatalogs';
import { getDeadCatalogsCall } from 'src/apis/getCatalogCalls';
import LoadingSpinner from 'src/shared/loading/loading';


export const validationSchema = Yup.object().shape(
  {
    deadCatalogName: Yup.string().nullable()
      .required('Dead Catalog Name is Required'),
    oneHr: Yup.number().nullable().min(0, "1 HR Stick Radius must be greater than or equal to 0")
      .max(10, "1 HR Stick Radius must be less than or equal to 10")
      .required('1 HR Stick Radius is Required'),
    tenHr: Yup.number().nullable().min(0, "10 HR Stick Radius must be greater than or equal to 0")
      .max(10, "10 HR Stick Radius must be less than or equal to 10")
      .required('10 HR Stick Radius is Required'),
    hundredHr: Yup.number().nullable().min(0, "100 HR Stick Radius must be greater than or equal to 0")
      .max(10, "100 HR Stick Radius must be less than or equal to 10")
      .required('100 HR Stick Radius is Required'),
    thousandHr: Yup.number().nullable().min(0, "1000 HR Stick Radius must be greater than or equal to 0")
      .max(10, "1000 HR Stick Radius must be less than or equal to 10")
      .required('1000 HR Stick Radius is Required'),
  }
);

type ReportProps ={
  setOpen: any,
  setCreateUpdateDeadSuccess: any,
  editDead?: any,
}
interface FormVals {
  deadCatalogId: number|null,
  deadCatalogName: string,

  oneHr: number|null,
  tenHr: number|null,
  hundredHr: number|null,
  thousandHr: number|null,
}
export const AddDeadCatalog: React.FC<ReportProps> = ({setOpen, setCreateUpdateDeadSuccess, editDead}) =>{

  const [, dispatch] = useStoreContext();
  const addAlert = useAddAlert(dispatch);
  const [loading,setLoading] = useState<boolean>(false)
  
  const [initVals, setInitVals] = useState<FormVals>({
    deadCatalogId: null,
    deadCatalogName: '',
    oneHr: null,
    tenHr: null,
    hundredHr: null,
    thousandHr: null,
  })

  const handleSubmit= (values:any)=>{
    (async()=>{
      try{
        setLoading(true)
        const paramsToSend = {
          id: values.deadCatalogId===null? null: Number(values.deadCatalogId),
          name: values.deadCatalogName,
          hr1StickRadius: Number(values.oneHr),
          hr10StickRadius: Number(values.tenHr),
          hr100StickRadius: Number(values.hundredHr),
          hr1000StickRadius: Number(values.thousandHr),

        }
        const response:any = await createUpdateDeadCatalogCall(paramsToSend, addAlert);
        if(response?.data.data.createUpdateDeadFuelCatalog.data.name?.length>0){
          setCreateUpdateDeadSuccess(true)
          //save banner
          if(values.deadCatalogId===null){
            errorResponse('', addAlert, `The Dead Fuel Catalog, ${response.data.data.createUpdateDeadFuelCatalog.data.name}, was saved.`, true);
          }
          else{
            errorResponse('', addAlert, `The changes to the Dead Fuel Catalog, ${response.data.data.createUpdateDeadFuelCatalog.data.name}, was saved.`, true);
          }
          
          setOpen(false)
        }
        setLoading(false)
      }
      catch(error:any){
        setLoading(false)
        console.log('error', error);
        if(error?.message?.toLowerCase().includes('unique')){
          addAlert({
            id: '',
            message: alertMessages.uniqueCatalogName,
            type: 'error-info',
            icon: 'fa-exclamation-triangle'
          })
        }
        else{
          addAlert({
            id: '',
            message: alertMessages.deadCatalogCreate,
            type: 'error-info',
            icon: 'fa-exclamation-triangle'
          })
        }
      }
    })();
  }

    /** Make the api call for the dead catalog detail */
    const deadCatalogCallback = useCallback((request: any) => {
      (async () => {
        try {
          const deadCatalogResponse: any = await getDeadCatalogsCall(request, addAlert);
          if (deadCatalogResponse.data.length > 0) {
            let editValues = {
              deadCatalogId: deadCatalogResponse.data[0].id,
              deadCatalogName: deadCatalogResponse.data[0].catalogName,
              oneHr: deadCatalogResponse.data[0].stickRadius1HrFuelMoisture,
              tenHr: deadCatalogResponse.data[0].stickRadius10HrFuelMoisture,
              hundredHr: deadCatalogResponse.data[0].stickRadius100HrFuelMoisture,
              thousandHr: deadCatalogResponse.data[0].stickRadius1000HrFuelMoisture,
            }
            setInitVals(editValues);
          }
  
        } catch (error) {
          addAlert({
            id: '',
            message: alertMessages.retrieveCatalog,
            type: 'error-info',
            icon: 'fa-exclamation-triangle'
          });
        }
      })();
    }, [addAlert]);
    
  /* use Effect to check and make a call to get the edit area */
  useEffect(()=>{
      if(editDead){
        const request = {
          id: Number(editDead),
          perPage: 10000,
          page: 0,
          sortBy: 'dead_fuel_parameter_catalog_name',
          sortOrder: 'asc',
        }
        deadCatalogCallback(request)
      }
      else{
        let initValues={
            deadCatalogId: null,
            deadCatalogName: '',
            oneHr: null,
            tenHr: null,
            hundredHr:null,
            thousandHr: null,
        }
        setInitVals(initValues);
      }

  },[addAlert, editDead, deadCatalogCallback]);
  
  return(
  <GridContainer className="removePadding smooth-scrollbar" style={{height: '80%', maxHeight: '95%', minHeight:'50%', overflowX: 'hidden', paddingBottom: '2rem'}}>
      {(loading) && (
        <div>
          <LoadingSpinner />
        </div>
      )}
    <Grid row gap="md" className='page-heading'>
      <Grid
        desktop={{col:12}}
        className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 paddingForModal">
          {
            editDead ? (
              <span className="font-sans-lg text-bold">Edit Dead Fuel Catalog</span>
            ):(
              <span className="font-sans-lg text-bold">Add a New Dead Fuel Catalog</span>
            )
          }
      </Grid>
    </Grid>
    <hr style={{width: '100%', marginBottom: '2rem', marginTop: '2rem'}}></hr>

    <Formik
      initialValues={initVals}
      validateOnBlur={true}
      validateOnChange={true}
      validateOnMount={true}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={(values) => handleSubmit(values) }>
      {({
        values,
        errors,
        touched,
        handleSubmit,
        setFieldValue,
        isValid,
        setFieldTouched
      }) => { 
          const setValue = (event: any, type: string) => {
            setFieldTouched(type);
            if (event.target.value.length === 1 && /^\s/.test(event.target.value)) {
              return
            }
            if(type!=='deadCatalogName'){
                if (regex2decimals.test(event.target.value.toString())) {
                    setFieldValue(type, event.target.value);
                    return
                }
            }
            else{
              setFieldValue(type, event.target.value);
            }
          }
          return (
            <Form onSubmit={handleSubmit}>
                  <div className="paddingForm">
                    <Grid row desktop={{ col: 7 }}>

                          <label id={'CreateUpdatedeadCatalogName'} htmlFor={'CreateUpdatedeadCatalogName'}>Dead Catalog Name*</label>
                          <TextField
                              value={values.deadCatalogName}
                              onBlur={() => setFieldTouched('deadCatalogName')}
                              error={!!errors.deadCatalogName && !!touched.deadCatalogName}
                              helperText={errors.deadCatalogName && touched.deadCatalogName ? errors.deadCatalogName : ''}
                              id={'CreateUpdatedeadCatalogName'}
                              type={'string'}
                              size='medium'
                              fullWidth
                              onChange={(e: any) => {setValue(e, 'deadCatalogName') }}
                              placeholder={'Enter Dead Catalog Name'}
                          />
                      </Grid>
                      <Grid row desktop={{ col: 7 }}>

                          <label id={'CreateUpdateoneHr'} htmlFor={'CreateUpdateoneHr'}>1 HR Stick Radius*</label>
                          <TextField
                              value={values.oneHr}
                              onBlur={() => setFieldTouched('oneHr')}
                              error={!!errors.oneHr && !!touched.oneHr}
                              helperText={errors.oneHr && touched.oneHr ? errors.oneHr : ''}
                              id={'CreateUpdateoneHr'}
                              type={'string'}
                              size='medium'
                              fullWidth
                              onChange={(e: any) => {setValue(e, 'oneHr') }}
                              placeholder={'Enter 1 Hr Stick Radius'}

                              InputProps={{
                                  inputProps: {
                                      min: 0,
                                      max: 10
                                  }
                              }}
                          />
                      </Grid>
                    <Grid row desktop={{ col: 7 }}>

                          <label id={'CreateUpdatetenHr'} htmlFor={'CreateUpdatetenHr'}>10 HR Stick Radius*</label>
                          <TextField
                              value={values.tenHr}
                              onBlur={() => setFieldTouched('tenHr')}
                              error={!!errors.tenHr && !!touched.tenHr}
                              helperText={errors.tenHr && touched.tenHr ? errors.tenHr : ''}
                              id={'CreateUpdatetenHr'}
                              type={'string'}
                              size='medium'
                              fullWidth
                              onChange={(e: any) => {setValue(e, 'tenHr') }}
                              placeholder={'Enter 10 Hr Stick Radius'}

                              InputProps={{
                                  inputProps: {
                                      min: 0,
                                      max: 10
                                  }
                              }}
                          />
                      </Grid>

                        <Grid row desktop={{ col: 7 }}>

                          <label id={'CreateUpdatehundredHr'} htmlFor={'CreateUpdatehundredHr'}>100 HR Stick Radius*</label>
                          <TextField
                              value={values.hundredHr}
                              onBlur={() => setFieldTouched('hundredHr')}
                              error={!!errors.hundredHr && !!touched.hundredHr}
                              helperText={errors.hundredHr && touched.hundredHr ? errors.hundredHr : ''}
                              id={'CreateUpdatehundredHr'}
                              type={'string'}
                              size='medium'
                              fullWidth
                              onChange={(e: any) => {setValue(e, 'hundredHr') }}
                              placeholder={'Enter 100 Hr Stick Radius'}

                              InputProps={{
                                  inputProps: {
                                      min: 0,
                                      max: 10
                                  }
                              }}
                          />
                      </Grid>
                    <Grid row desktop={{ col: 7 }}>

                          <label id={'CreateUpdatethousandHr'} htmlFor={'CreateUpdatethousandHr'}>1000 HR Stick Radius*</label>
                          <TextField
                              value={values.thousandHr}
                              onBlur={() => setFieldTouched('thousandHr')}
                              error={!!errors.thousandHr && !!touched.thousandHr}
                              helperText={errors.thousandHr && touched.thousandHr ? errors.thousandHr : ''}
                              id={'CreateUpdatethousandHr'}
                              type={'string'}
                              size='medium'
                              fullWidth
                              onChange={(e: any) => {setValue(e, 'thousandHr') }}
                              placeholder={'Enter 1000 Hr Stick Radius'}

                              InputProps={{
                                  inputProps: {
                                      min: 0,
                                      max: 10
                                  }
                              }}
                          />
                      </Grid>

                  </div>

              <Grid row className='modalBottomDiv'>
                <Grid desktop={{ col: 10 }} className="modalCancelDiv">
                  <Button variant="outlined" style={{ backgroundColor: 'white' }} onClick={() => { setOpen(false) }}>
                    Cancel
                  </Button>
                </Grid>
                {
                  editDead ? (
                    <Grid desktop={{ col: 2 }} className='modalSubmitDiv'>
                      <Button variant="contained" type="submit" aria-disabled={!isValid}>
                        Save
                      </Button>
                    </Grid>
                  ) : (
                    <Grid desktop={{ col: 2 }} className='modalSubmitDiv'>
                      <Button variant="contained" type="submit" aria-disabled={!isValid}>
                        Add
                      </Button>
                    </Grid>
                  )
                }
              </Grid>
            </Form>
          )
        }}
    </Formik>
  </GridContainer>
  )
}